import React from 'react';
import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Icon} from 'front-onceforall-core';
import {withRouter} from 'react-router-dom';
import * as snackbarsActions from '../../actions/snackbars';
import config from '../../../config';

import {
  CONTENT_CATEGORY_DOCUMENT,
  CONTENT_CATEGORY_OPTION,
  CONTENT_CATEGORY_PARAMETER,
  CONTENT_CATEGORY_PROJECT,
  CONTENT_CATEGORY_MODEL,
  CONTENT_CATEGORY_ACCESS,
  CONTENT_CATEGORY_SUBCONTRACTOR,
  CONTENT_CATEGORY_CLIENT
} from '../../helpContent/constants';
import HelpContentDetails from './HelpContentDetails';

import helpContentDe from '../../helpContent/de/helpContent';
import helpContentFr from '../../helpContent/fr/helpContent';
import helpContentEn from '../../helpContent/en/helpContent';
import helpContentIt from '../../helpContent/it/helpContent';
import HelpContentPreview from './HelpContentPreview';
import {pathResolver} from '../../utils/basePathHelper';

const categories = [
  {
    label: CONTENT_CATEGORY_DOCUMENT,
    icon: 'document',
    color: 'styled active reverted'
  },
  {
    label: CONTENT_CATEGORY_CLIENT,
    icon: 'switch-organisation',
    color: 'styled active reverted'
  },
  {
    label: CONTENT_CATEGORY_SUBCONTRACTOR,
    icon: 'switch-organisation',
    color: 'styled active reverted'
  },
  {
    label: CONTENT_CATEGORY_PROJECT,
    icon: 'organisation',
    color: 'styled active reverted'
  },
  {
    label: CONTENT_CATEGORY_OPTION,
    icon: 'cog',
    color: 'styled active reverted'
  },
  {
    label: CONTENT_CATEGORY_PARAMETER,
    icon: 'cog',
    color: 'styled active reverted'
  },
  {
    label: CONTENT_CATEGORY_ACCESS,
    icon: 'user',
    color: 'styled active reverted'
  },
  {
    label: CONTENT_CATEGORY_MODEL,
    icon: 'document',
    color: 'styled active reverted'
  }
];
const helpContentList = {
  de: helpContentDe,
  fr: helpContentFr,
  en: helpContentEn,
  it: helpContentIt
};

export class HelpCenter extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      selectedCategory: null
    };

    this.getContentList = this.getContentList.bind(this);
    this.handleClickFilter = this.handleClickFilter.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleContactCustomerClick = this.handleContactCustomerClick.bind(this);
  }

  componentDidMount() {
    const selectedContent = this.getSelectedContent();
    if (selectedContent) {
      this.setState({selectedCategory: selectedContent.categories[0]});
    }
  }

  getFAQUrl() {
    return 'https://demo.herothemes.com/knowall/';
  }

  getContentList() {
    return helpContentList[this.props.currentLocale];
  }

  getSelectedContent() {
    return this.getContentList()
      .find(content => this.props.selectedHelpContent && content.id === this.props.selectedHelpContent);
  }

  handleClickFilter(category) {
    return () => {
      this.setState({
        selectedCategory: this.state.selectedCategory === category ? null : category
      });
    };
  }

  handleBack() {
    if (this.getSelectedContent()) {
      this.props.history.replace(`${this.props.currentPath}?help`);
    } else if (this.state.selectedCategory) {
      this.setState({selectedCategory: null});
    } else {
      this.props.onClose();
    }
  }

  handleContactCustomerClick(event) {
    event.preventDefault();
    event.stopPropagation();
    return this.props.onOpenContactForm();
  }

  render() {
    const categoryFilters = categories.map((category, index) => (
      <div
        className="col-sm-3 mt-3"
        key={index}
      >
        <button
          type="button"
          className="col-12 box clickable"
          onClick={this.handleClickFilter(category.label)}
          style={{height: '100%'}}
        >
          <span className="inline-container inline-container column align-items-center information">
            <span
              className={`round-chip-l ${category.color}`}
            >
              <Icon
                size={25}
                icon={category.icon}
              />
            </span>
            <strong><Translate value={`helpCenter.category.${category.label}`}/></strong>
          </span>
        </button>
      </div>
    ));

    const selectedContent = this.getSelectedContent();
    let content = null;
    if (selectedContent) {
      content = (
        <HelpContentDetails
          content={selectedContent}
          onOpenContactForm={this.props.onOpenContactForm}
        />
      );
    } else if (this.state.selectedCategory) {
      content = this.getContentList()
        .filter(contentItem => contentItem.categories.includes(this.state.selectedCategory))
        .map((contentItem, index) => {
          const {icon} = categories
            .find(category => (this.state.selectedCategory ?
              category.label === this.state.selectedCategory :
              contentItem.categories[0] === category.label));
          return (<HelpContentPreview
            content={contentItem}
            key={index}
            icon={icon}
            history={this.props.history}
            currentPath={this.props.currentPath}
          />);
        });
    } else {
      content = (<div
        className="flex-container column space-between"
        style={{height: '100%'}}
      >

        {!config.featureFlags.newHelpCenter &&
          <div>
            <p><Translate value="helpCenter.selectACategory"/></p>
            <div className="row justify-content-center mb-5">
              <div className="col-md-10 col-lg-9">
                <div className="row justify-content-center">
                  {categoryFilters}
                </div>
              </div>
            </div>
          </div>
        }

        {config.featureFlags.newHelpCenter &&
          <div className="row justify-content-center mb-5">
            <div className="col-md-10">
              <div className="flex-container align-items-center">
                <img
                  alt="help"
                  src={pathResolver('resources/img/faq.png')}
                  style={{width: '100%', maxWidth: 230}}
                />
                <div className="inline-container column ml-5">
                  <span className="font-size-l">
                  Une question à propos de notre application ? N&apos;hésitez pas à consulter notre base de connaissances
                  </span>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={this.getFAQUrl()}
                  >
                    <button className="large primary inline-container mt-4">
                      <span>Consulter</span>
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        }
      </div>);
    }

    return (
      <div
        className="d-flex flex-column space-between"
        style={{height: 'calc(100vh - 74px)'}}
      >
        <div className="mb-2">
          <div className="row">
            <div className={'col-12 inline-container space-between mb-3'}>
              {!this.state.selectedCategory && <h2 className="m-0"><Translate value="helpCenter.title"/></h2>}
              {this.state.selectedCategory && <>
                <h3 className="inline-container m-0">
                  <span
                    className="clickable no-wrap"
                    onClick={() => {
                      if (selectedContent) {
                        this.props.history.replace(`${this.props.currentPath}?help`);
                      }

                      this.setState({selectedCategory: null});
                    }}
                  >
                    <Translate value="helpCenter.title"/>
                  </span>
                  <span className="caret-right"/>
                  <span
                    className={selectedContent ? 'clickable no-wrap' : 'no-wrap'}
                    onClick={() => (selectedContent ?
                      this.props.history.replace(`${this.props.currentPath}?help`) : () => {})}
                  >
                    <Translate value={`helpCenter.category.${this.state.selectedCategory}`}/>
                  </span>
                </h3>
              </>
              }
              <button onClick={this.props.onClose}>
                <Icon
                  icon="cross"
                  size={20}
                />
              </button>
            </div>

          </div>
        </div>

        <div
          className="p-3"
          style={{overflowY: 'auto', overflowX: 'hidden', height: '100%'}}
        >
          {content}
        </div>

        <div>
          <hr className="my-4"/>

          <div className="actions col-12 inline-container space-between">
            <button
              type="button"
              className="large secondary inline-container no-wrap"
              onClick={this.handleBack}
              data-id="cancel"
            >
              <Icon icon="go-back"/>
              <Translate value={this.state.selectedCategory ? 'action.back' : 'action.close'}/>
            </button>
            <span>
              <Translate value="helpCenter.contactCustomerService"/>&nbsp;
              <span
                className="clickable"
                onClick={this.handleContactCustomerClick}
              >
                <Translate value="helpCenter.contactCustomerServiceLink"/>
              </span>
            </span>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    organisation: state.organisation,
    currentLocale: state.i18n.locale
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({...snackbarsActions}, dispatch)
  };
}

HelpCenter.propTypes = {
  selectedHelpContent: PropTypes.string,
  currentPath: PropTypes.string.isRequired,
  onOpenContactForm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  currentLocale: PropTypes.string.isRequired
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HelpCenter));
